import { render } from "./AlertBox.vue?vue&type=template&id=20ab1c18&scoped=true&ts=true"
import script from "./AlertBox.vue?vue&type=script&lang=ts"
export * from "./AlertBox.vue?vue&type=script&lang=ts"

import "./AlertBox.vue?vue&type=style&index=0&id=20ab1c18&scoped=true&lang=scss"

import exportComponent from "/builds/Moodbuster2.0/server/web-server/repos/patient_portal_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ab1c18"]])

export default __exports__